import router from './../router';
import http from "@/services/http.js";
import { useAuth } from "@/stores/auth.js";
let startTime = Date.now();


function updateStartTime() {
  startTime = Date.now();
}

function logTimeSpent(pageName) {
  const endTime = Date.now();
  const timeSpent = endTime - startTime; // Tempo trascorso in secondi


  const domain = window.location.hostname;
  if (domain == 'neurohub.it' || domain == 'www.neurohub.it')
  {


    try
    {
      const auth = useAuth();
      http.post('/tracking', {
        time: timeSpent,
        path: pageName,
        email: (auth && auth.user) ? auth.user.email : null
      });
    } catch (error)
    {
      console.log(error);
    }
  }


}

router.beforeEach((to, from, next) => {
  logTimeSpent(from.fullPath);
  next();
});

router.afterEach((to) => {
  console.log(to);
  updateStartTime();
  //document.title = to.name || 'Home'; // Cambia il titolo del documento
});